import React from 'react';
import PropTypes from 'prop-types';
import * as Styled from './styles';
import { getSportTypeConfig } from '../../sports/configs';

const Entry = ({
    sportType,
    isPlayerBased,
    selectionName,
    selectionIcon,
    selectionNumber
}) => {
    const sportConfig = getSportTypeConfig(sportType, isPlayerBased);
    const isRacing = sportType === 'racing';
    const isAwaiting = !selectionName;
    const iconSrc =
        (!isAwaiting && selectionIcon) ||
        sportConfig.assets.defaultSelectionIcon;

    return (
        <Styled.Wrapper>
            <Styled.Label>
                Your {sportConfig.labels.selectionNounCapitalized}
            </Styled.Label>
            <Styled.Selection>
                <Styled.Holder>
                    {!isAwaiting && isRacing && selectionNumber != null && (
                        <Styled.SelectionNumber>
                            {selectionNumber}
                        </Styled.SelectionNumber>
                    )}
                    <Styled.Icon sportType={sportType}>
                        <img
                            src={iconSrc}
                            alt={selectionName || 'Awaiting allocation'}
                        />
                    </Styled.Icon>
                </Styled.Holder>
                <Styled.NameBox sportType={sportType}>
                    {selectionName || 'Awaiting Allocation'}
                </Styled.NameBox>
            </Styled.Selection>
        </Styled.Wrapper>
    );
};

Entry.defaultProps = {
    isPlayerBased: false,
    selectionName: undefined,
    selectionIcon: null,
    selectionNumber: null
};

Entry.propTypes = {
    sportType: PropTypes.oneOf(['racing', 'football']).isRequired,
    isPlayerBased: PropTypes.bool,
    selectionName: PropTypes.string,
    selectionIcon: PropTypes.string,
    selectionNumber: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};

export default Entry;
